import { conformsTo, isArrayAndEveryElement, isBoolean, isString, isUndefinedOr } from '@dmb/core';

export type NotificationSettings = {
  code: string;
  channelSettings: {
    mobile: boolean;
    web: boolean;
    email?: boolean;
  };
  labels: {
    de?: string;
    en: string;
  };
}[];

export const isNotificationPreferencesResponse = conformsTo<{ topics: NotificationSettings }>({
  topics: isArrayAndEveryElement(
    conformsTo({
      code: isString,
      channelSettings: conformsTo({
        mobile: isBoolean,
        web: isBoolean,
        email: isUndefinedOr(isBoolean),
      }),
      labels: conformsTo({
        de: isUndefinedOr(isString),
        en: isString,
      }),
    }),
  ),
});

export enum EventStatus {
  READ = 'read',
  CREATED = 'created',
  PINNED = 'pinned',
}

function isEventStatus(val: unknown): val is EventStatus {
  return val === EventStatus.READ || val === EventStatus.CREATED || val === EventStatus.PINNED;
}

export type NotificationEvent = {
  eventId: string;
  eventStatus: EventStatus;
  title: string;
  message: string;
  payload:
    | {
        downloadLink: string | undefined;
        productLink: string | undefined;
      }
    | undefined;
  validUntil: string | undefined; // ISO Date
};

export const isNotificationEvent = conformsTo<NotificationEvent>({
  eventId: isString,
  eventStatus: isEventStatus,
  title: isString,
  message: isString,
  payload: isUndefinedOr(
    conformsTo({
      downloadLink: isUndefinedOr(isString),
      productLink: isUndefinedOr(isString),
    }),
  ),
  validUntil: isUndefinedOr(isString),
});

export type PushNotification = {
  data: {
    downloadLink: string | undefined;
    productLink: string | undefined;
    eventId: string;
  };
  notification: {
    title: string;
    body: string;
  };
};

export const isPushNotification = conformsTo<PushNotification>({
  data: conformsTo({
    downloadLink: isUndefinedOr(isString),
    productLink: isUndefinedOr(isString),
    eventId: isString,
  }),
  notification: conformsTo({
    title: isString,
    body: isString,
  }),
});
